export const Types = {
    GET_UNPLANNED_MAINTENANCE_ACTIVE_COUNTS: "GET_UNPLANNED_MAINTENANCE_ACTIVE_COUNTS",
    SET_UNPLANNED_MAINTENANCE_ACTIVE_COUNTS: "SET_UNPLANNED_MAINTENANCE_ACTIVE_COUNTS",
    GET_PLANNED_MAINTENANCE_ACTIVE_COUNTS: "GET_PLANNED_MAINTENANCE_ACTIVE_COUNTS",
    SET_PLANNED_MAINTENANCE_ACTIVE_COUNTS: "SET_PLANNED_MAINTENANCE_ACTIVE_COUNTS",
    GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
    SET_NOTIFICATIONS: "SET_NOTIFICATIONS",
    GET_BARCODE_CONTENT: "GET_BARCODE_CONTENT",
    SET_BARCODE_CONTENT: "SET_BARCODE_CONTENT",
};

export const getUnplannedMaintenanceActiveCounts = (username) => ({
    type: Types.GET_UNPLANNED_MAINTENANCE_ACTIVE_COUNTS,
    payload: username,
});

export const setUnplannedMaintenanceActiveCounts = (payload) => ({
    type: Types.SET_UNPLANNED_MAINTENANCE_ACTIVE_COUNTS,
    payload: payload,
});

export const getPlannedMaintenanceActiveCounts = (username) => ({
    type: Types.GET_PLANNED_MAINTENANCE_ACTIVE_COUNTS,
    payload: username,
});

export const setPlannedMaintenanceActiveCounts = (payload) => ({
    type: Types.SET_PLANNED_MAINTENANCE_ACTIVE_COUNTS,
    payload: payload,
});

export const getNotifications = (username) => ({
    type: Types.GET_NOTIFICATIONS,
    payload: username,
});

export const setNotifications = (payload) => ({
    type: Types.SET_NOTIFICATIONS,
    payload: payload,
});

export const getBarcodeContent = (payload) => ({
    type: Types.GET_BARCODE_CONTENT,
    payload: payload,
});

export const setBarcodeContent = (payload) => ({
    type: Types.SET_BARCODE_CONTENT,
    payload: payload.data,
});